import {NgModule} from "@angular/core";
import {PageNotFoundComponent} from "./page-not-found.component";
import {ErrorComponent} from "./error.component";
import {BrowserModule} from "@angular/platform-browser";
import {SuccessComponent} from "./success.component";
import {StatusIndicatorComponent} from "./status-indicator.component";
import {HttpClientModule} from "@angular/common/http";
import {ErrorService} from "./error.service";
import {ErrorDisplayComponent} from "./error-display.component";
import {ValidationErrorDisplayComponent} from "./validation-error-display.component";

@NgModule({
  providers: [ErrorService],
  imports: [BrowserModule, HttpClientModule],
  declarations: [
    ErrorComponent,
    ErrorDisplayComponent,
    SuccessComponent,
    PageNotFoundComponent,
    StatusIndicatorComponent,
    ValidationErrorDisplayComponent,
  ],
  exports: [
    ErrorComponent,
    SuccessComponent,
    PageNotFoundComponent,
    StatusIndicatorComponent,
    ValidationErrorDisplayComponent,
  ],
})
export class ErrorModule {}
